import type { BackgroundColorToken } from '@canvas/constants/colors/tokens-types';
import type { Identity } from '@canvas/model/identity';
import { createPingRegistry, type PingRegistry } from '@canvas/ping-registry';

interface Participant {
  identity: Identity;
  colorToken: BackgroundColorToken;
}

type DatabasePingConfig = {
  cell: {
    key: { fieldId: string; entryId: string };
    changes: {
      presence: Participant[];
      editing: boolean;
    };
  };
  row: {
    key: { entryId: string };
    changes: {
      presence: Participant[];
      selected: boolean;
    };
  };
  column: {
    key: { fieldId: string };
    changes: {
      presence: Participant[];
    };
  };
  headerCheckbox: {
    key: Record<string, never>;
    changes: {
      state: 'checked' | 'indeterminate' | 'unchecked';
    };
  };
};

const databasesPingRegistry = createPingRegistry<DatabasePingConfig>({
  encode: {
    cell: ({ fieldId, entryId }) => `cell::${fieldId}::${entryId}`,
    row: ({ entryId }) => `row::${entryId}`,
    column: ({ fieldId }) => `column::${fieldId}`,
    headerCheckbox: () => `headerCheckbox`,
  },
});

export type DatabasesPingRegistry = PingRegistry<DatabasePingConfig>;

// Named exports for destructuring
export const { key, subscribe, subscribeTo, notify } = databasesPingRegistry;

// Default export for full registry access
export default databasesPingRegistry;
